const VERSION = 1;
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export const liveDraftKey = (userId, liveId) => userId ? `nymia:live-draft:v${VERSION}:${userId}:${liveId || 'new'}` : null;

const localInput = (iso) => {
  const date = new Date(iso);
  if (!Number.isFinite(date.getTime())) return null;
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

const validShape = (value, defaults) => value && typeof value === 'object'
  && Object.keys(defaults).every((key) => key === 'duration_minutes'
    ? ['number', 'string'].includes(typeof value[key])
    : typeof value[key] === typeof defaults[key]);

export const readLiveDraft = (key, defaults, source) => {
  if (!key) return null;
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  let saved;
  try { saved = JSON.parse(raw); } catch (_) { localStorage.removeItem(key); return null; }
  if (saved?.version !== VERSION || !Number.isFinite(saved.savedAt)
      || Date.now() - saved.savedAt > MAX_AGE_MS || !validShape(saved.form, defaults)
      || (source && saved.source !== source)) {
    localStorage.removeItem(key);
    return null;
  }
  // Whitelist fields and restore the same scheduled instant in the device's
  // current timezone, rather than silently shifting a draft after travel.
  const form = Object.fromEntries(Object.keys(defaults).map((field) => [field, saved.form[field]]));
  if (saved.scheduledAt) form.scheduled_local = localInput(saved.scheduledAt) || form.scheduled_local;
  return form;
};

export const writeLiveDraft = (key, form, source) => {
  if (!key) return;
  const scheduled = new Date(form.scheduled_local);
  localStorage.setItem(key, JSON.stringify({ version: VERSION, savedAt: Date.now(), source, form,
    scheduledAt: Number.isFinite(scheduled.getTime()) ? scheduled.toISOString() : null }));
};